import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { APIService } from '../api/api.service'
import { AppearanceService } from '../appearance/appearance.service';
import { Constants } from '../../constants/constants';
import { JobModel } from 'src/app/models/job.model';
import { AssetModel } from 'src/app/models/asset.model';
import { format, parseISO } from 'date-fns';
import { FileModel } from 'src/app/models/file.model';
import { FilterModel } from 'src/app/models/filter.model';
import { AssetFieldModel } from 'src/app/models/asset_field.model';
import { ObservationModel } from 'src/app/models/observation.model';
import { HistoryModel } from 'src/app/models/history.model';
import { GeoObjectModel } from 'src/app/models/geoobject.model';
import { AssetPresetFieldsModel } from 'src/app/models/asset_preset_fields.model';
import { RemedialModel } from 'src/app/models/remedial.model';
import { HeicCertModel } from 'src/app/models/heic_cert.model';
import { RiskFormModel } from 'src/app/models/risk-form.model';
import { AssetPresetStlModel } from 'src/app/models/asset_preset_stl.model';
import { ConditionReportModel } from 'src/app/models/condition-report.model';
import { AssetTypeModel } from 'src/app/models/asset-type.model';
import { throwError } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class JobService 
{
  createJobTypeUid: number;
  createdJobUid: number;

  currentJob: JobModel = null;
  currentAsset: AssetModel = null;


  constructor(private apiService: APIService, private appearanceService: AppearanceService) 
  {
    this.initService();
  }


  initService()
  {
    this.apiService.baseUrl = Constants.PROD_URL;

    this.appearanceService.listenForEvent('storage:loaded', (data: any) => {

      this.loadFromLocalData();

    });
  }


  loadFromLocalData() 
  {
    this.createJobTypeUid = null;
    this.createdJobUid = null;
  }


  public createNewJob(job): any 
  { 
    return this.apiService.createNewJob(job).pipe(map((response: any) => {
      
        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public updateJob(job): any 
  { 
    return this.apiService.updateJob(job).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public addJobHistoryLog(payload): any 
  { 
    return this.apiService.addJobHistoryLog(payload).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }

  
  public addAssignableAssetToJob(payload): any 
  { 
    return this.apiService.addAssignableAssetToJob(payload).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public removeAssignableAssetFromJob(payload): any 
  { 
    return this.apiService.removeAssignableAssetFromJob(payload).pipe(map((response: any) => {
      
        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public createJobCompletedFile(payload): any 
  { 
    return this.apiService.createJobCompletedFile(payload).pipe(map((response: any) => {
      
        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }

  
  public addAssetToJob(payload): any 
  { 
    return this.apiService.addAssetToJob(payload).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public updateJobRiskForm(payload): any 
  { 
    return this.apiService.updateJobRiskForm(payload).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public createJobAlert(payload): any 
  { 
    return this.apiService.createAlert(payload).pipe(map((response: any) => {
      
        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public updateJobAssetDetails(payload): any 
  { 
    return this.apiService.updateJobAssetDetails(payload).pipe(map((response: any) => {
      
        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public removeAssetFromJob(payload): any 
  { 
    return this.apiService.removeAssetFromJob(payload).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public deleteJobFile(fileUid, clientUid, organisationUid): any 
  { 
    var payload = {
      FileUid: fileUid,
      ClientUid: clientUid,
      OrganisationUid: organisationUid
    }

    return this.apiService.deleteJobFile(payload).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public deleteJob(jobUid, clientUid, organisationUid): any 
  { 
    var payload = {
      JobUid: jobUid,
      ClientUid: clientUid,
      OrganisationUid: organisationUid
    }

    return this.apiService.deleteJob(payload).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public getJobDetails(jobUid, clientUid, organisationUid): any 
  { 
    var payload = {
      JobUid: jobUid,
      ClientUid: clientUid,
      OrganisationUid: organisationUid
    }

    return this.apiService.getJobDetails(payload).pipe(map((response: any) => {

      if (response.Success)
      {
          this.currentJob = new JobModel();

          this.currentJob.jobUid                      = response.Job.jobUid;
          this.currentJob.jobId                       = response.Job.jobId;
          this.currentJob.clientUid                   = response.Job.clientUid;
          this.currentJob.clientOrderNumber           = response.Job.clientOrderNumber;
          this.currentJob.jobDateMysql                = response.Job.jobDateMysql;
          this.currentJob.jobDate                     = new Date(this.currentJob.jobDateMysql).toISOString();
          this.currentJob.jobDateReadable             = format(parseISO(this.currentJob.jobDateMysql), 'do MMM yyyy HH:mm:ss');
          this.currentJob.visitNumber                 = response.Job.visitNumber;
          this.currentJob.jobInformation              = response.Job.jobInformation;
          this.currentJob.addressOne                  = response.Job.addressOne;
          this.currentJob.addressTwo                  = response.Job.addressTwo;
          this.currentJob.addressCity                 = response.Job.addressCity;
          this.currentJob.postCode                    = response.Job.postCode;
          this.currentJob.locationEstate              = response.Job.locationEstate;
          this.currentJob.locationUid                 = response.Job.locationUid;
          this.currentJob.userDesignerUid             = response.Job.userDesignerUid;
          this.currentJob.userDesignerName            = response.Job.userDesignerName;
          this.currentJob.userDesignerDateMysql       = response.Job.userDesignerDateMysql;
          this.currentJob.priority                    = response.Job.priority;
          this.currentJob.jobTypeUid                  = response.Job.jobTypeUid;
          this.currentJob.jobTypeName                 = response.Job.jobTypeName;
          this.currentJob.jobStatusUid                = response.Job.jobStatusUid;
          this.currentJob.jobStatusName               = response.Job.jobStatusName;
          this.currentJob.locationName                = response.Job.locationName;
          this.currentJob.organisationName            = response.Job.organisationName;
          this.currentJob.organisationUid             = response.Job.organisationUid;
          this.currentJob.userManagerUid              = response.Job.userManagerUid;
          this.currentJob.userManagerName             = response.Job.userManagerName;
          this.currentJob.userManagerDateMysql        = response.Job.userManagerDateMysql;
          this.currentJob.userManagerNotes            = response.Job.userManagerNotes;
          this.currentJob.userInstallerUid            = response.Job.userInstallerUid;
          this.currentJob.userInstallerName           = response.Job.userInstallerName;
          this.currentJob.userInstallerDateMysql      = response.Job.userInstallerDateMysql;
          this.currentJob.userInstallerNotes          = response.Job.userInstallerNotes;
          this.currentJob.returnNeededNotes           = response.Job.returnNeededNotes;
          this.currentJob.designerSignature           = null;
          this.currentJob.installerSignature          = null;
          this.currentJob.managerSignature            = null;
          this.currentJob.designerSignatureFound      = false;
          this.currentJob.installerSignatureFound     = false;
          this.currentJob.managerSignatureFound       = false;
          this.currentJob.files                       = new Array<FileModel>();
          this.currentJob.assignableAssetTypes        = new Array<AssetTypeModel>();
          this.currentJob.assets                      = new Array<AssetModel>();
          this.currentJob.heicCertificate             = null;
          this.currentJob.riskForm                    = null;

          if (response.Job.jobRiskForm)
          {
            this.currentJob.riskForm = new RiskFormModel();
            this.currentJob.riskForm.riskFormUid                      = response.Job.jobRiskForm.riskFormUid;
            this.currentJob.riskForm.enviromentRisk                   = response.Job.jobRiskForm.enviromentRisk;
            this.currentJob.riskForm.enviromentRiskAction             = response.Job.jobRiskForm.enviromentRiskAction;
            this.currentJob.riskForm.enviromentRiskControls           = response.Job.jobRiskForm.enviromentRiskControls;
            this.currentJob.riskForm.excavationRisk                   = response.Job.jobRiskForm.excavationRisk;
            this.currentJob.riskForm.excavationRiskAction             = response.Job.jobRiskForm.excavationRiskAction;
            this.currentJob.riskForm.excavationRiskControls           = response.Job.jobRiskForm.excavationRiskControls;
            this.currentJob.riskForm.undergroundElectricRisk          = response.Job.jobRiskForm.undergroundElectricRisk;
            this.currentJob.riskForm.undergroundElectricRiskAction    = response.Job.jobRiskForm.undergroundElectricRiskAction;
            this.currentJob.riskForm.undergroundElectricRiskControls  = response.Job.jobRiskForm.undergroundElectricRiskControls;
            this.currentJob.riskForm.undergroundGasRisk               = response.Job.jobRiskForm.undergroundGasRisk;
            this.currentJob.riskForm.undergroundGasRiskAction         = response.Job.jobRiskForm.undergroundGasRiskAction;
            this.currentJob.riskForm.undergroundGasRiskControls       = response.Job.jobRiskForm.undergroundGasRiskControls;
            this.currentJob.riskForm.undergroundWaterRisk             = response.Job.jobRiskForm.undergroundWaterRisk;
            this.currentJob.riskForm.undergroundWaterRiskAction       = response.Job.jobRiskForm.undergroundWaterRiskAction;
            this.currentJob.riskForm.undergroundWaterRiskControls     = response.Job.jobRiskForm.undergroundWaterRiskControls;
            this.currentJob.riskForm.undergroundBtRisk                = response.Job.jobRiskForm.undergroundBtRisk;
            this.currentJob.riskForm.undergroundBtRiskAction          = response.Job.jobRiskForm.undergroundBtRiskAction;
            this.currentJob.riskForm.undergroundBtRiskControls        = response.Job.jobRiskForm.undergroundBtRiskControls;
            this.currentJob.riskForm.undergroundOtherRisk             = response.Job.jobRiskForm.undergroundOtherRisk;
            this.currentJob.riskForm.undergroundOtherRiskAction       = response.Job.jobRiskForm.undergroundOtherRiskAction;
            this.currentJob.riskForm.undergroundOtherRiskControls     = response.Job.jobRiskForm.undergroundOtherRiskControls;
            this.currentJob.riskForm.trafficManagementRisk            = response.Job.jobRiskForm.trafficManagementRisk;
            this.currentJob.riskForm.trafficManagementRiskAction      = response.Job.jobRiskForm.trafficManagementRiskAction;
            this.currentJob.riskForm.trafficManagementRiskControls    = response.Job.jobRiskForm.trafficManagementRiskControls;
            this.currentJob.riskForm.manholeRiskElelement             = response.Job.jobRiskForm.manholeRiskElelement;
            this.currentJob.riskForm.manholeRiskElelementAction       = response.Job.jobRiskForm.manholeRiskElelementAction;
            this.currentJob.riskForm.manholeRiskElelementControls     = response.Job.jobRiskForm.manholeRiskElelementControls;
            this.currentJob.riskForm.materialsRiskElement             = response.Job.jobRiskForm.materialsRiskElement;
            this.currentJob.riskForm.materialsRiskElementAction       = response.Job.jobRiskForm.materialsRiskElementAction;
            this.currentJob.riskForm.materialsRiskElementControls     = response.Job.jobRiskForm.materialsRiskElementControls;
            this.currentJob.riskForm.toolsRiskElement                 = response.Job.jobRiskForm.toolsRiskElement;
            this.currentJob.riskForm.toolsRiskElementAction           = response.Job.jobRiskForm.toolsRiskElementAction;
            this.currentJob.riskForm.toolsRiskElementControls         = response.Job.jobRiskForm.toolsRiskElementControls;
            this.currentJob.riskForm.reinstatementRiskElement         = response.Job.jobRiskForm.reinstatementRiskElement;
            this.currentJob.riskForm.reinstatementRiskElementAction   = response.Job.jobRiskForm.reinstatementRiskElementAction;
            this.currentJob.riskForm.reinstatementRiskElementControls = response.Job.jobRiskForm.reinstatementRiskElementControls;
            this.currentJob.riskForm.otherRiskElement                 = response.Job.jobRiskForm.otherRiskElement;
            this.currentJob.riskForm.otherRiskElementAction           = response.Job.jobRiskForm.otherRiskElementAction;
            this.currentJob.riskForm.otherRiskElementControls         = response.Job.jobRiskForm.otherRiskElementControls;
          }

          this.currentJob.riskFormMessage = this.getRiskAssessmentErrors(this.currentJob.riskForm);

          // PPM.
          if (response.Job.jobTypeUid == "1")
          {
            if (response.Job.certConfig)
            {
              this.currentJob.heicCertificate = new HeicCertModel();
              this.currentJob.heicCertificate.insResistCont                 = response.Job.certConfig.insResistCont;
              this.currentJob.heicCertificate.eliEarthElec                  = response.Job.certConfig.eliEarthElec;
              this.currentJob.heicCertificate.rcd                           = response.Job.certConfig.rcd;
              this.currentJob.heicCertificate.other                         = response.Job.certConfig.other;
              this.currentJob.heicCertificate.intervalYears                 = response.Job.certConfig.intervalYears;
              this.currentJob.heicCertificate.departures                    = response.Job.certConfig.departures;
              this.currentJob.heicCertificate.remarks                       = response.Job.certConfig.remarks;
              this.currentJob.heicCertificate.jobCertConfigUid              = response.Job.certConfig.jobCertConfigUid;
              this.currentJob.heicCertificate.bandOneAndTwo                 = response.Job.certConfig.bandOneAndTwo;
              this.currentJob.heicCertificate.presenceOfIsolationSwitching  = response.Job.certConfig.presenceOfIsolationSwitching;
              this.currentJob.heicCertificate.supplyIntakeCond              = response.Job.certConfig.supplyIntakeCond;
              this.currentJob.heicCertificate.presenceEarthConductor        = response.Job.certConfig.presenceEarthConductor;
              this.currentJob.heicCertificate.adaquacyOfAccess              = response.Job.certConfig.adaquacyOfAccess;
              this.currentJob.heicCertificate.presenceOfCpc                 = response.Job.certConfig.presenceOfCpc;
              this.currentJob.heicCertificate.presenceOfDiagrams            = response.Job.certConfig.presenceOfDiagrams;
              this.currentJob.heicCertificate.singlePoleDevices             = response.Job.certConfig.singlePoleDevices;
              this.currentJob.heicCertificate.sElvPelvFelv                  = response.Job.certConfig.sElvPelvFelv;
              this.currentJob.heicCertificate.presenceBondingConstructor    = response.Job.certConfig.presenceBondingConstructor;
              this.currentJob.heicCertificate.idOfConductors                = response.Job.certConfig.idOfConductors;
              this.currentJob.heicCertificate.measuresExternalInfluence     = response.Job.certConfig.measuresExternalInfluence;
              this.currentJob.heicCertificate.doubleInsualtion              = response.Job.certConfig.doubleInsualtion;
              this.currentJob.heicCertificate.choiceSettingProtDevices      = response.Job.certConfig.choiceSettingProtDevices;
              this.currentJob.heicCertificate.surgePresentAndOk             = response.Job.certConfig.surgePresentAndOk;
              this.currentJob.heicCertificate.electSeperation               = response.Job.certConfig.electSeperation;
              this.currentJob.heicCertificate.selectionOfConductors         = response.Job.certConfig.selectionOfConductors;
              this.currentJob.heicCertificate.insualtionOfLiveParts         = response.Job.certConfig.insualtionOfLiveParts;
              this.currentJob.heicCertificate.presenceOfRcds                = response.Job.certConfig.presenceOfRcds;
              this.currentJob.heicCertificate.installtionMethods            = response.Job.certConfig.installtionMethods;
              this.currentJob.heicCertificate.barriersEnclosure             = response.Job.certConfig.barriersEnclosure;
              this.currentJob.heicCertificate.protectedAgainstMechDamage    = response.Job.certConfig.protectedAgainstMechDamage;
              this.currentJob.heicCertificate.placingOutOfReach             = response.Job.certConfig.placingOutOfReach;
              this.currentJob.heicCertificate.proxToNonElectricalServices   = response.Job.certConfig.proxToNonElectricalServices;
              this.currentJob.heicCertificate.connectionOfConductors        = response.Job.certConfig.connectionOfConductors;
              this.currentJob.heicCertificate.rcdFunctionalTestOk           = response.Job.certConfig.rcdFunctionalTestOk;
              this.currentJob.heicCertificate.disconnectionTime             = response.Job.certConfig.disconnectionTime;
            }
            else
            {
              this.currentJob.heicCertificate = this.getDefaultHeicCert();
            }
          }

          if (this.currentJob.userDesignerDateMysql)
          {
            this.currentJob.userDesignerDate            = new Date(this.currentJob.userDesignerDateMysql).toISOString();
            this.currentJob.userDesignerDateReadable    = format(parseISO(this.currentJob.userDesignerDateMysql), 'do MMM yyyy HH:mm:ss');
          }
          
          if (this.currentJob.userInstallerDateMysql)
          {
            this.currentJob.userInstallerDate           = new Date(this.currentJob.userInstallerDateMysql).toISOString();
            this.currentJob.userInstallerDateReadable   = format(parseISO(this.currentJob.userInstallerDateMysql), 'do MMM yyyy HH:mm:ss');
          }
          
          if (this.currentJob.userManagerDateMysql)
          {
            this.currentJob.userManagerDate             = new Date(this.currentJob.userManagerDateMysql).toISOString();
            this.currentJob.userManagerDateReadable     = format(parseISO(this.currentJob.userManagerDateMysql), 'do MMM yyyy HH:mm:ss');
          }

          if (this.currentJob.organisationUid)
          {
            var filter = new FilterModel();
            filter.uid = Number(this.currentJob.organisationUid);
            filter.name = this.currentJob.organisationName;
            this.currentJob.organisationSelect = filter;
          }

          if (this.currentJob.jobTypeUid)
          {
            var filter = new FilterModel();
            filter.uid = Number(this.currentJob.jobTypeUid);
            filter.name = this.currentJob.jobTypeName;
            this.currentJob.jobTypeSelect = filter;
          }

          if (this.currentJob.userDesignerUid)
          {
            var filter = new FilterModel();
            filter.uid = Number(this.currentJob.userDesignerUid);
            filter.name = this.currentJob.userDesignerName;
            this.currentJob.userDesignerSelect = filter;
          }

          if (this.currentJob.userInstallerUid)
          {
            var filter = new FilterModel();
            filter.uid = Number(this.currentJob.userInstallerUid);
            filter.name = this.currentJob.userInstallerName;
            this.currentJob.userInstallerSelect = filter;
          }

          if (this.currentJob.userManagerUid)
          {
            var filter = new FilterModel();
            filter.uid = Number(this.currentJob.userManagerUid);
            filter.name = this.currentJob.userManagerName;
            this.currentJob.userManagerSelect = filter;
          }

          if (this.currentJob.jobStatusUid)
          {
            var filter = new FilterModel();
            filter.uid = Number(this.currentJob.jobStatusUid);
            filter.name = this.currentJob.jobStatusName;
            this.currentJob.jobStatusSelect = filter;
          }

          for (var i = 0; i < response.Job.jobFiles.length; i++)
          {
            var theFile       = response.Job.jobFiles[i];

            var newFile       = new FileModel();
            newFile.s3Path    = theFile.s3Path;
            newFile.fileName  = theFile.filename;
            newFile.datetime  = theFile.datetime;
            newFile.uid       = Number(theFile.fileUid);
            
            this.currentJob.files.push(newFile);
          }

          this.currentJob.locationGeoJson = Array<GeoObjectModel>();
  
          for (var i = 0; i < response.Job.locationGeoJson.length; i++)
          {
            var geo = response.Job.locationGeoJson[i];

            var newGeo = new GeoObjectModel();

            newGeo.geometry   = geo.geometry;
            newGeo.properties = geo.properties;
            newGeo.type       = geo.type;

            this.currentJob.locationGeoJson.push(newGeo);
          }

          for (var i = 0; i < response.Job.assignableAssetTypes.length; i++)
          {
            var entry = response.Job.assignableAssetTypes[i];

            var newAssetType = new AssetTypeModel();

            newAssetType.assetTypeUid           = entry.assetTypeUid;
            newAssetType.assetTypeName          = entry.assetTypeName;
            newAssetType.assetTypeIcon          = entry.assetTypeIcon;
            newAssetType.requireConditionReport = Boolean(JSON.parse(entry.requireConditionReport));
            newAssetType.isStreetLight           = Boolean(JSON.parse(entry.isStreetLight));
            newAssetType.fields                 = new Array<AssetFieldModel>();
            newAssetType.allFieldValuePresets   = new Array<AssetPresetFieldsModel>();

            for (var x = 0; x < entry.Fields.length; x++)
            {
              var fieldEntry = entry.Fields[x];

              var newField          = new AssetFieldModel();
              newField.uid          = fieldEntry.assetFieldUid;
              newField.name         = fieldEntry.assetFieldName;
              newField.keyboardType = fieldEntry.keyboardType;
              newField.value        = null;

              newAssetType.fields.push(newField);
            }

            for (var x = 0; x < entry.Presets.length; x++)
            {
              var presetEntry = entry.Presets[x];
              
              var newPreset = new AssetPresetFieldsModel();

              newPreset.uid           = presetEntry.assetPresetUid;
              newPreset.name          = presetEntry.assetPresetName;
              newPreset.defaultValues = JSON.parse(presetEntry.assetPresetValues);

              newAssetType.allFieldValuePresets.push(newPreset);
            }

            this.currentJob.assignableAssetTypes.push(newAssetType);
          }

          for (var i = 0; i < response.Job.assets.length; i++)
          {
            var assetApi = response.Job.assets[i];

            var newAsset = new AssetModel();

            newAsset.uid                      = assetApi.assetUid;
            newAsset.name                     = assetApi.assetName;
            newAsset.jobAssetUid              = Number(assetApi.jobAssetUid);
            newAsset.powerIssue               = Boolean(assetApi.powerIssue);
            newAsset.fields                   = new Array<AssetFieldModel>();
            newAsset.observations             = new Array<ObservationModel>();
            newAsset.photos                   = new Array<FileModel>();
            newAsset.recommededBreakdowns     = [];
            newAsset.repairBreakdowns         = [];
            newAsset.hasImages                = Boolean(JSON.parse(assetApi.hasImages));

            //TODO
            //newAsset.isStreetLight            = Boolean(JSON.parse(assetApi.isStreetLight));
            //newAsset.assetTypeIcon            = assetApi.assetTypeIcon;
            //newAsset.allStlPresets            = new Array<AssetPresetStlModel>();
            //newAsset.requireConditionReport   = Boolean(JSON.parse(assetApi.requireConditionReport));
            //newAsset.assetTypeUid             = Number(assetApi.assetTypeUid);
            //newAsset.assetTypeName            = assetApi.assetTypeName;

            newAsset.assetType = new AssetTypeModel();
            newAsset.assetType.isStreetLight            = Boolean(JSON.parse(assetApi.isStreetLight));
            newAsset.assetType.assetTypeIcon            = assetApi.assetTypeIcon;
            newAsset.assetType.allStlPresets            = new Array<AssetPresetStlModel>();
            newAsset.assetType.requireConditionReport   = Boolean(JSON.parse(assetApi.requireConditionReport));
            newAsset.assetType.assetTypeUid             = Number(assetApi.assetTypeUid);
            newAsset.assetType.assetTypeName            = assetApi.assetTypeName;

            console.log(assetApi);

            for (var x = 0; x < assetApi.repairBreakdowns.length; x++)
            {
              var newRepairObs = assetApi.repairBreakdowns[x];
              newAsset.repairBreakdowns.push(newRepairObs);
            }

            for (var x = 0; x < assetApi.recommendedBreakdowns.length; x++)
            {
              var newRecommendedObs = assetApi.recommendedBreakdowns[x];
              newAsset.recommededBreakdowns.push(newRecommendedObs);
            }
            
            for (var x = 0; x < assetApi.field_string.length; x++)
            {
              var fieldEntry = assetApi.field_string[x];

              var newField          = new AssetFieldModel();
              newField.uid          = fieldEntry.uid;
              newField.name         = fieldEntry.assetTypeFieldName;
              newField.value        = fieldEntry.value;
              newField.keyboardType = fieldEntry.assetTypeFieldKeyboard;

              newAsset.fields.push(newField);
            }

            for (var x = 0; x < assetApi.stlPresets.length; x++)
            {
              var stlPresetEntry = assetApi.stlPresets[x];
              
              var newStlPreset = new AssetPresetStlModel();

              newStlPreset.uid           = stlPresetEntry.presetUid;
              newStlPreset.name          = stlPresetEntry.presetName;
              newStlPreset.description   = stlPresetEntry.description;
              newStlPreset.defaultStls   = stlPresetEntry.remedials;

              // TODO
              //newAsset.allStlPresets.push(newStlPreset);

              newAsset.assetType.allStlPresets.push(newStlPreset);
            }

            for (var x = 0; x < assetApi.observations.length; x++)
            {
                var entry = assetApi.observations[x];

                var newObs                                = new ObservationModel();
                newObs.uid                                = Number(entry.observationUid);
                newObs.observationInfo                    = entry.observationInfo;
                newObs.conditionCode                      = entry.conditionCode;
                newObs.ref                                = entry.observationRef;
                newObs.observedDateTime                   = entry.observedDateTime;
                newObs.chosenRemedials                    = new Array<RemedialModel>();
                newObs.customRemedials                    = new Array<RemedialModel>();
                newObs.presetStlRemedialUids              = new Array<any>(); // TODO - Needs to come from db. // @Fil Can be removed once updated to use model below
                newObs.currentStlPresets                  = new Array<AssetPresetStlModel>(); 
                newObs.loggedByUser                       = entry.loggedByUser;
                newObs.repairedOnJobUid                   = entry.repairedOnJobUid;
                newObs.recommendedOnJobUid                = entry.recommendedOnJobUid;
                newObs.repairedByUser                     = entry.repairedByUser;
                newObs.recommendedByUser                  = entry.recommendedByUser;
                newObs.repairNotes                        = entry.repairNotes;
                newObs.condemnAssetReuseParts             = entry.condemnAssetReuseParts;
                newObs.condemnAssetReusePartsText         = entry.condemnAssetReusePartsText;
                newObs.condemnAssetIsolated               = entry.condemnAssetIsolated;
                newObs.condemnFuseRemoved                 = entry.condemnFuseRemoved;
                newObs.condemnAssetSufficientLighting     = entry.condemnAssetSufficientLighting;
                newObs.condemnAssetDangerousPosition      = entry.condemnAssetDangerousPosition;
                newObs.condemnAssetDangerousPositionText  = entry.condemnAssetDangerousPositionText;
                newObs.observedDateTimeReadable          = entry.observedDateTimeReadable;
                newObs.recommendedDateTimeReadable       = entry.recommendedDateTimeReadable;
                newObs.repairedDateTimeReadable          = entry.repairedDateTimeReadable;

                newObs.repairedDateTime     = null;
                newObs.recommendedDateTime  = null;
                newObs.powerIssue           = null;

                if (entry.powerIssue)
                {
                  newObs.powerIssue = entry.powerIssue;
                }

                if (entry.repairedDateTime) 
                {
                  newObs.repairedDateTime = entry.repairedDateTime;
                }

                if (entry.recommendedDateTime) 
                {
                  newObs.recommendedDateTime = entry.recommendedDateTime;
                }
               
                for (var y = 0; y < entry.remedials.length; y++)
                {
                  var newRemedial = new RemedialModel();

                  newRemedial.assetObservationRemedialUid   = Number(entry.remedials[y].assetObservationRemedialUid);
                  newRemedial.quantity                      = Number(entry.remedials[y].stlQuantity);
                  newRemedial.stlCode                       = entry.remedials[y].stlCode;
                  newRemedial.name                          = entry.remedials[y].remedialName;
                  newRemedial.remedialUid                   = Number(entry.remedials[y].remedialUid);

                  newObs.chosenRemedials.push(newRemedial)
                }   

                for (var z = 0; z < entry.customRemedials.length; z++)
                {
                  var newCustomRemedial = new RemedialModel();
    
                  newCustomRemedial.assetObservationCustomRemedialUid   = Number(entry.customRemedials[z].assetObservationCustomRemedialUid);
                  newCustomRemedial.stlCode                             = entry.customRemedials[z].customRemedialCode;
                  newCustomRemedial.name                                = entry.customRemedials[z].customRemedialName;
                  newCustomRemedial.charge                              = entry.customRemedials[z].customRemedialCharge;
    
                  newObs.customRemedials.push(newCustomRemedial)
                }

                for (var z = 0; z < entry.stlPresets.length; z++)
                {
                  // @Fil Can be removed once updated to use model below
                  newObs.presetStlRemedialUids.push(entry.stlPresets[z].stlPresetUid);

                  var newStlPreset  = new AssetPresetStlModel();
                  newStlPreset.uid  = entry.stlPresets[z].stlPresetUid;
                  newStlPreset.name = entry.stlPresets[z].stlPresetName;
                  
                  newObs.currentStlPresets.push(newStlPreset);
                }   

                newAsset.observations.push(newObs);
            }
            
            for (var z = 0; z < assetApi.photos.length; z++)
            {
              var theFile = assetApi.photos[z];

              var newFile       = new FileModel();
              newFile.s3Path    = theFile.s3Path;
              newFile.fileName  = theFile.filename;
              newFile.fileType  = theFile.fileType;
              newFile.datetime  = theFile.datetime;
              newFile.uid       = Number(theFile.fileUid);

              newAsset.photos.push(newFile);
            }

            newAsset.conditionReport = new ConditionReportModel();

            if(assetApi.conditionReport)
            {
              newAsset.conditionReport.reportCreatedDateTime  = assetApi.conditionReport.conditionReportDateTime;
              newAsset.conditionReport.reportUid = assetApi.conditionReport.conditionReportUid;
              newAsset.conditionReport.approxAge  = assetApi.conditionReport.approxAge;
              newAsset.conditionReport.condition  = assetApi.conditionReport.condition;
              newAsset.conditionReport.notes      = assetApi.conditionReport.notes;

              if (assetApi.conditionReport.columnTypeOther)
              {
                newAsset.conditionReport.columnType = assetApi.conditionReport.columnTypeOther;
              }
              else
              {
                newAsset.conditionReport.columnType = assetApi.conditionReport.columnType;
              }
  
              if (assetApi.conditionReport.headTypeOther)
              {
                newAsset.conditionReport.headType = assetApi.conditionReport.headTypeOther;
              }
              else
              {
                newAsset.conditionReport.headType = assetApi.conditionReport.headType;
              }
            }

            this.currentJob.assets.push(newAsset);
          }

          this.currentJob.history = Array<HistoryModel>();

          for (var i = 0; i < response.Job.history.length; i++)
          {
            var log = response.Job.history[i];

            var newLog      = new HistoryModel();
            newLog.uid      = log.historyUid;
            newLog.dateTime = log.historyDateTime;
            newLog.log      = log.HistoryLog;
            newLog.userName = log.historyUser;
            
            this.currentJob.history.push(newLog);
          }

          // PPM Job.
          if (this.currentJob.jobTypeUid == 1)
          {
            var payload = {
              jobUid: this.currentJob.jobUid,
              clientUid: this.currentJob.clientUid
            }

            this.getDesignerSignature(payload);
            this.getInstallerSignature(payload);
            this.getManagerSignature(payload);
          }
      }
      
      return response;
    }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  private getDefaultHeicCert(): HeicCertModel
  {
    var defaultCert = new HeicCertModel();

    defaultCert.jobCertConfigUid              = null;
    defaultCert.bandOneAndTwo                 = "NA";
    defaultCert.presenceOfIsolationSwitching  = "Yes";
    defaultCert.supplyIntakeCond              = "NA";
    defaultCert.presenceEarthConductor        = "Yes";
    defaultCert.adaquacyOfAccess              = "Yes";
    defaultCert.presenceOfCpc                 = "Yes";
    defaultCert.presenceOfDiagrams            = "Yes";
    defaultCert.singlePoleDevices             = "Yes";
    defaultCert.sElvPelvFelv                  = "NA";
    defaultCert.presenceBondingConstructor    = "Yes";
    defaultCert.idOfConductors                = "Yes";
    defaultCert.measuresExternalInfluence     = "Yes";
    defaultCert.doubleInsualtion              = "NA";
    defaultCert.choiceSettingProtDevices      = "Yes";
    defaultCert.surgePresentAndOk             = "NA";
    defaultCert.electSeperation               = "NA";
    defaultCert.selectionOfConductors         = "Yes";
    defaultCert.insualtionOfLiveParts         = "Yes";
    defaultCert.presenceOfRcds                = "NA";
    defaultCert.installtionMethods            = "Yes";
    defaultCert.barriersEnclosure             = "Yes";
    defaultCert.protectedAgainstMechDamage    = "Yes";
    defaultCert.placingOutOfReach             = "NA";
    defaultCert.proxToNonElectricalServices   = "NA";
    defaultCert.connectionOfConductors        = "Yes";
    defaultCert.rcdFunctionalTestOk           = "NA";
    defaultCert.insResistCont                 = "";
    defaultCert.eliEarthElec                  = "";
    defaultCert.rcd                           = "";
    defaultCert.other                         = "";
    defaultCert.intervalYears                 = "2";
    defaultCert.departures                    = "";
    defaultCert.remarks                       = "";
    defaultCert.disconnectionTime             = "5";

    return defaultCert;
  }


  private getRiskAssessmentErrors(riskForm): string
  {
    if (!riskForm)
    {
      return "none";
    }

    var count = 0;

    if (riskForm.enviromentRisk == "Y")
    {
      count++;
    }
    if (riskForm.excavationRisk == "Y")
    {
      count++;
    }
    if (riskForm.undergroundElectricRisk == "Y")
    {
      count++;
    }
    if (riskForm.undergroundGasRisk == "Y")
    {
      count++;
    }
    if (riskForm.undergroundWaterRisk == "Y")
    {
      count++;
    }
    if (riskForm.undergroundBtRisk == "Y")
    {
      count++;
    }
    if (riskForm.undergroundOtherRisk == "Y")
    {
      count++;
    }
    if (riskForm.trafficManagementRisk == "Y")
    {
      count++;
    }
    if (riskForm.manholeRiskElelement == "Y")
    {
      count++;
    }
    if (riskForm.materialsRiskElement == "Y")
    {
      count++;
    }
    if (riskForm.toolsRiskElement == "Y")
    {
      count++;
    }
    if (riskForm.reinstatementRiskElement == "Y")
    {
      count++;
    }
    if (riskForm.otherRiskElement == "Y")
    {
      count++;
    }

    if (count == 0)
    {
      return "zero";
    }

    if (count == 1)
    {
      return "one";
    }
    
    return count + "";
  }


  public printJob(data): any 
  { 
    return this.apiService.printJob(data).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }

  public generateJobSurveyQuote(data): any 
  { 
    return this.apiService.generateJobSurveyQuote(data).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  async getDesignerSignature(payload)
  { 
    this.currentJob.designerSignatureFound = false;

    this.apiService.getDesignerSignature(payload).subscribe((response: any) => {

        if (response.Success)
        {
          this.currentJob.designerSignatureFound = true;
          this.currentJob.designerSignature = response.Image;
        }      
      },
      err => {

    });
  }


  async getInstallerSignature(payload)
  { 
    this.currentJob.installerSignatureFound = false;

    this.apiService.getInstallerSignature(payload).subscribe((response: any) => {

        if (response.Success)
        {
          this.currentJob.installerSignatureFound = true;
          this.currentJob.installerSignature = response.Image;
        }
      },
      err => {

    });
  }


  async getManagerSignature(payload)
  { 
    this.currentJob.managerSignatureFound = false;

    this.apiService.getManagerSignature(payload).subscribe((response: any) => {

        if (response.Success)
        {
          this.currentJob.managerSignatureFound = true;
          this.currentJob.managerSignature = response.Image;
        }
      },
      err => {

    });
  }


  public uploadSignature(data): any
  {
    return this.apiService.uploadSignature(data).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public addEngineerToJob(data): any
  {
    return this.apiService.addEngineerToJob(data).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public removeEngineerFromJob(data): any
  {
    return this.apiService.removeEngineerFromJob(data).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public getJobLocationGeo(data): any
  {
    return this.apiService.getJobLocationGeo(data).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public placeNewAssetOnMap(data): any 
  {
    return this.apiService.placeNewAssetOnMap(data).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public moveAssetOnMap(data): any 
  {
    return this.apiService.moveAssetOnMap(data).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public createHeicCertificate(certModel): any 
  { 
    return this.apiService.createHeicCertificate(certModel).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public downloadHeicCertificate(data): any 
  { 
    return this.apiService.downloadHeicCertificate(data).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }


  public getAddressesFromPostCode(postCode, organisationUid): any 
  { 
    return this.apiService.getAddressesFromPostCode(postCode, organisationUid).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }

  public exportJobDetailsToExcel(payload): any 
  { 
    return this.apiService.exportJobDetailsToExcel(payload).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }

  public getJobAssetImage(payload): any 
  { 
    return this.apiService.getJobAssetImage(payload).pipe(map((response: any) => {

        return response;
      }),
      catchError((err) => { return throwError(() => err);  })
    );
  }

  setCreatingJobType(createJobTypeUid)
  {
    this.createJobTypeUid = createJobTypeUid;
  }

  getCreatingJobTypeUid()
  {
    if (this.createJobTypeUid)
    {
      return this.createJobTypeUid;
    }

    return 1;
  }

  getCurrentJob(): JobModel
  {
    if (this.currentJob)
    {
      return this.currentJob;
    }

    return null;
  }

  getCurrentJobUid(): number
  {
    if (this.currentJob)
    {
      return this.currentJob.jobUid;
    }

    return null;
  }

  public isPpmJob()
  {
    if (this.currentJob)
    {
      if (this.currentJob.heicCertificate)
      {
        return true;
      }
    }

    return false;
  }

  
  public getHeicCertConfig(): HeicCertModel
  {
    if (this.currentJob)
    {
      return this.currentJob.heicCertificate;
    }

    return null;
  }


  public getPresetsForAssetType(assetTypeUid): Array<AssetPresetFieldsModel>
  {
    if (this.currentJob)
    {
      for (var i = 0; i < this.currentJob.assignableAssetTypes.length; i++)
      {
        if (this.currentJob.assignableAssetTypes[i].assetTypeUid == assetTypeUid)
        {
          return this.currentJob.assignableAssetTypes[i].allFieldValuePresets;
        }
      }
    }

    return [];
  }
}
